import React from 'react'

import PropTypes from 'prop-types'

import './nlp2.css'

const Nlp2 = (props) => {
  return (
    <div
      id={props.ID}
      className="npl2-layout349 thq-section-padding"
    >
      <section id="2" className="npl2-max-width thq-section-max-width">
        <div className="npl2-content">
          <div className="npl2-section-title">
            <div className="npl2-content1">
              <h2 className="thq-heading-2">{props.Title}</h2>
              <p className="thq-body-large">{props.Description}</p>
              <p className="thq-body-large">{props.session}</p>
              <p className="thq-body-large">{props.leader}</p>
              <h2 className="npl1-text3 thq-heading-2">{props.cost}</h2>
            </div>
            <div className="npl2-actions">
              <a
                href={props.link}
                target="_blank"
                rel="noreferrer noopener"
                className="npl2-button-ready thq-button-filled"
              >
                <span className="thq-body-small">{props.Action1}</span>
              </a>
            </div>
          </div>
        </div>
        <div className="npl2-image-container">
          <img
            alt={props.ImageAlt}
            src={props.ImageSrc}
            className="npl2-placeholder-image thq-img-ratio-16-9"
          />
        </div>
      </section>
    </div>
  )
}

Nlp2.defaultProps = {
  ID: '2',
  ImageSrc: 'https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTcyMDMzNTcyMXw&ixlib=rb-4.0.3&q=80&w=1080',
  cost: '$200',
  Description: 'Our courses are taught by experts in the fields of real estate, business.',
  Title: 'Expert-Led Courses',
  Action1: 'Enroll Now',
  ImageAlt: 'Expert-Led Courses Image',
  session: '12 sessions total 2 session per weak',
  leader: 'By Neeta Sisodiya',
  link: 'https://www.amitworldacademy.com',
}

Nlp2.propTypes = {
  ID: PropTypes.string,
  ImageSrc: PropTypes.string,
  cost: PropTypes.string,
  Description: PropTypes.string,
  Title: PropTypes.string,
  Action1: PropTypes.string,
  ImageAlt: PropTypes.string,
  session: PropTypes.string,
  leader: PropTypes.string,
  link: PropTypes.string,
}

export default Nlp2
